import React from "react";

function Header() {
  return (
    <div className="header">
      <div className="logo">
        <img src="logo.png" />
      </div>
    </div>
  );
}

export default Header;
